import { Box } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ArrowLeftIcon } from 'Asset/icon';
import { Condition } from 'Component/others';
import { useAppSystem } from 'Store/app';
import { TextSemiBold } from 'UiKit/typography';
import { useHostStockPromoState } from 'View/host-stock-promo/state';

import styles from './styles.module.css';

const Head = ({ isDetailFromNavigation }) => {
  const { t } = useTranslation('host-stock-promo');
  const navigate = useNavigate();
  const { state, updateState, updateFilterState } = useHostStockPromoState();
  const { onChangeAppSystem } = useAppSystem();

  const getTitle = () => {
    if (state?.selectedDetailPromo) return t('promo_detail.title');
    if (state?.selectedDetailStock) return t('stock_detail.title');
    return t('page.title');
  };

  const title = getTitle();
  const isDetailView = state?.selectedDetailStock || state?.selectedDetailPromo;

  const handleBack = () => {
    if (isDetailFromNavigation) {
      onChangeAppSystem({ isHideMobileNavBar: false });
      navigate(-1);
    } else if (isDetailView) {
      updateState({ selectedDetailPromo: null, selectedDetailStock: null });
      onChangeAppSystem({ isHideMobileNavBar: false });
      updateFilterState({ page: 1 });
    } else {
      navigate(-1);
    }
  };

  return (
    <Box
      className={styles['head__container']}
      transform={!isDetailView && state?.showTopBar ? 'translateY(0)' : !isDetailView ? 'translateY(-48px)' : 'translateY(0)'}
      data-testid="head"
    >
      <Condition statement={isDetailView} children={<ArrowLeftIcon className={styles['head__arrow']} onClick={handleBack} />} />
      <TextSemiBold className={styles['head__title']}>{title}</TextSemiBold>
    </Box>
  );
};

export default Head;
